import type { Components } from 'react-markdown';

/**
 * Общие переопределения react-markdown для хвоста пузыря с float-метой времени:
 * без блочных `<p>`, иначе мета уезжает на следующую строку.
 */
export const MESSENGER_MARKDOWN_BUBBLE_TAIL_COMPONENTS: Partial<Components> = {
  br: () => <br />,
  a: ({ href, children, ...rest }) => (
    <a {...rest} href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  ),
  p: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  ul: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  ol: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  li: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  h1: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  h2: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  h3: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  h4: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  h5: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  h6: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  blockquote: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  table: () => null,
  thead: () => null,
  tbody: () => null,
  tr: () => null,
  th: () => null,
  td: () => null,
  pre: ({ children }) => <span className="messengerMdBase__inline">{children}</span>,
  code: ({ className, children, ...rest }) => {
    const isBlock = typeof className === 'string' && className.includes('language-');
    if (isBlock) return <span className="messengerMdBase__inline">{children}</span>;
    return (
      <code {...rest} className={className}>
        {children}
      </code>
    );
  },
};
